module.exports = __webpack_public_path__ + "static/media/dislike.1eca4416.svg";